"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (error) {
    if (error.graphQLErrors && error.graphQLErrors.length) {
        throw new Error(error.graphQLErrors[0].message);
    }

    if (error.networkError) {
        throw new Error(error.networkError.message);
    }

    throw error;
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/handleError.js
// module id = 930
// module chunks = 0